import { createCommand } from '@commander-js/extra-typings';
import type {
  CommandServices,
  GetRootCommandFn,
} from '@wix/cli-command-contract';

import { buildCommand } from './build.js';
import { envCommand } from './env.js';
import { previewCommand } from './preview.js';
import { releaseCommand } from './release.js';
import { devCommand } from './dev.js';
import { generateCommand } from './generate.js';

export const getRootCommand: GetRootCommandFn = async (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('astro')
    .enablePositionalOptions(true)
    .addCommand(buildCommand(services, cliVersion))
    .addCommand(envCommand(services, cliVersion))
    .addCommand(previewCommand(services, cliVersion))
    .addCommand(releaseCommand(services, cliVersion))
    .addCommand(devCommand(services, cliVersion))
    .addCommand(generateCommand(services, cliVersion));
};
